
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of, fromEvent } from 'rxjs';
import { CollectionViewer, SelectionModel } from '@angular/cdk/collections';

import { CustomerService } from '../../../services/customer.service';
import { catchError, finalize, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CommonfilterService } from '../../../services/commonfilter.service';
import { DeleteCustomerDialogComponent } from '../delete-customer-dialog/delete-customer-dialog.component';
import { ChangeStatusDialogComponent } from '../change-status-dialog/change-status-dialog.component';
import { EmailVerifyDialogComponent } from '../../../shared/components/email-verify-dialog/email-verify-dialog.component';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { ChangePhoneComponent } from '../change-phone/change-phone.component';
import { ChangeRealComponent } from '../change-real/change-real.component';
import { CouponService } from 'src/app/services/coupon.service';
import { IssueJcashComponent } from '../issue-jcash/issue-jcash.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-list-customer',
  templateUrl: './list-customer.component.html',
  styleUrls: ['./list-customer.component.css']
})
export class ListCustomerComponent implements OnInit, AfterViewInit, OnDestroy {
  collapsed;
  consumerCount: number;
  dataSource = new ConsumerDataSource(this.customerService);
  tableFilters = '';
  selectedRowIndex = -1;
  selectedRow = false;
  showToolBar = false;
  selection = new SelectionModel(true, []);
  displayedColumns = ['select', 'id', 'firstName', 'lastName', 'primaryMobileNo', 'email', 'createdDate', 'signedUp', 'status', 'type'];
  displayedColumns1 = ['id', 'firstName', 'lastName', 'primaryMobileNo', 'email', 'createdDate'];
  @ViewChild('go', {static: false}) button: ElementRef;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  consumerData: any = {};
  userAgentModal = 0;
  categoryModal = 0;
  configData: any = {};
  consumerStatus = [];
  userAgents: any;
  consumerCategory: any;
  filterParam: string;
  customerSpecificFilters: string;
  userAgentFilter: string;
  hideUserAgent = true;
  screenHeight;
  screenWidth;
  small_device_display = false;
  status: any;
  customerData: any = {}
  fromDashboard: boolean;
  fromOffer: boolean;
  customerDatas: any;
  issueCashBt: boolean;
  custArr = [];
  countryCode;
  phonefilter;
  primaryMobileNo;
  api_error;
  constructor(private customerService: CustomerService,
    private commonFilter: CommonfilterService,
    private dialog: MatDialog,
    private couponService: CouponService
  ) {
    this.commonFilter.getConfigData()
      .subscribe(res => {
        this.configData = res;
        this.consumerStatus = this.configData.consumerStatusType;
        this.consumerCategory = this.configData.analyticsCategory;
        this.userAgents = this.configData.userAgentType;

      });
    this.onResize();
  }
  // deleteCusotmerDialogRef:MatDialogRef<DeleteCustomerDialogComponent>
  ngOnInit() {
    this.customerData = this.couponService.retriveCustomerData();
    this.consumerData = this.customerService.retriveConsumerData();
    // console.log(this.consumerData)
    if (this.consumerData !== '{}' && this.consumerData.flag === true) {
      this.fromDashboard = true;
      // console.log(this.consumerData)
      this.tableFilters = this.consumerData.filterParam;
      this.consumerCount = this.consumerData.count;
      this.dataSource.loadCustomers(this.tableFilters, 'false', 0, 100);
      this.consumerData.flag = false;
      this.customerService.storeConsumerData(this.consumerData);
      this.hideUserAgent = false;
      this.userAgentModal = this.customerService.getUserAgentFilterParam();
      this.categoryModal = this.customerService.getConsumerCategory();
    }
    else if (this.customerData !== '{}' && this.customerData.flag === true) {
      this.fromOffer = true;
      this.tableFilters = this.customerData.filterParam;
      this.consumerCount = this.customerData.count;
      // console.log(this.customerData)
      this.dataSource.loadCustomersOffer(this.tableFilters, 'false', 0, 100);
      this.customerData.flag = false;
      this.couponService.storeCustomererData(this.customerData);
    }
    else {
      this.fromDashboard = true;
      // this.tableFilters=this.consumerData.filterParam;
      this.getTotalCount();
      this.dataSource.loadCustomers(this.tableFilters, 'false', 0, 100);
    }
  }
  onCategoryChange(event) {
    this.hideUserAgent = true;
    if (event.target.value !== '0') {
      this.hideUserAgent = false;
    }

  }
  clearFilterParamsofCustomer(filterSegment) {
    this.commonFilter.clearFilterParams(filterSegment);
  }
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  ngAfterViewInit() {
    console.log(this.countryCode)
    this.paginator.page
      .pipe(
        tap(() => this.loadCustomersPage())
      )
      .subscribe();
    fromEvent(this.button.nativeElement, 'click')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.tableFilters = this.commonFilter.createfilterParams('customer');
          console.log(this.countryCode)
          console.log(this.primaryMobileNo)
          this.customerSpecificFilters = this.commonFilter.filterParams_without_operators('consumer_category');
          if (this.countryCode) {
            if (this.primaryMobileNo === undefined || this.primaryMobileNo === '') {
              if (this.customerSpecificFilters !== '' || this.customerSpecificFilters !== undefined) {
                this.userAgentFilter = this.commonFilter.filterParams_without_operators('consumer_userAgent');
                this.filterParam = this.tableFilters + '&' + this.customerSpecificFilters + '&' + this.userAgentFilter + '&countryCode-eq=' + this.countryCode;
                this.api_error = 'Ph. no should be given along with Country code';
                setTimeout(() => {
                  this.api_error = '';
                }, 3000);
                this.consumerCount = 0;
              }
              else {
                this.filterParam = this.tableFilters + '&countryCode-eq=' + this.countryCode;
                this.api_error = 'Ph. no should be given along with Country code';
                setTimeout(() => {
                  this.api_error = '';
                }, 3000);
                this.consumerCount = 0;
              }
            }
            else {
              if (this.customerSpecificFilters !== '' || this.customerSpecificFilters !== undefined) {
                this.userAgentFilter = this.commonFilter.filterParams_without_operators('consumer_userAgent');
                this.filterParam = this.tableFilters + '&' + this.customerSpecificFilters + '&' + this.userAgentFilter + '&countryCode-eq=' + this.countryCode + '&&primaryMobileNo-eq=' + this.primaryMobileNo;
              }
              else {
                this.filterParam = this.tableFilters + '&countryCode-eq=' + this.countryCode + '&&primaryMobileNo-eq=' + this.primaryMobileNo;
              }
            }

          }

          else if(this.primaryMobileNo) {
            if (this.countryCode === undefined || this.countryCode === '') {
              if (this.customerSpecificFilters !== '' || this.customerSpecificFilters !== undefined) {
                this.userAgentFilter = this.commonFilter.filterParams_without_operators('consumer_userAgent');
                this.filterParam = this.tableFilters + '&' + this.customerSpecificFilters + '&' + this.userAgentFilter + '&primaryMobileNo-eq=' + this.primaryMobileNo;
                this.api_error = 'Country code should be given along with ph no';
                setTimeout(() => {
                  this.api_error = '';
                }, 3000);
                this.consumerCount = 0;
              }
              else {
                this.filterParam = this.tableFilters + '&primaryMobileNo-eq=' + this.primaryMobileNo;
                this.api_error = 'Country code should be given along with ph no';
                setTimeout(() => {
                  this.api_error = '';
                }, 3000);
                this.consumerCount = 0;
              }
            }
            else {
              if (this.customerSpecificFilters !== '' || this.customerSpecificFilters !== undefined) {
                this.userAgentFilter = this.commonFilter.filterParams_without_operators('consumer_userAgent');
                this.filterParam = this.tableFilters + '&' + this.customerSpecificFilters + '&' + this.userAgentFilter + '&countryCode-eq=' + this.countryCode + '&&primaryMobileNo-eq=' + this.primaryMobileNo;
              }
              else {
                this.filterParam = this.tableFilters + '&countryCode-eq=' + this.countryCode + '&&primaryMobileNo-eq=' + this.primaryMobileNo;
              }
            }

          }
          else if(this.customerSpecificFilters !== '' || this.customerSpecificFilters !== undefined){
            this.userAgentFilter = this.commonFilter.filterParams_without_operators('consumer_userAgent');
            this.filterParam = this.filterParam = this.tableFilters + '&' + this.customerSpecificFilters + '&' + this.userAgentFilter
          }
          else{
            this.filterParam = this.tableFilters
          }









          // else if (this.primaryMobileNo) {
          //   if (this.countryCode === undefined || this.countryCode === '') {
          //     alert('3')
          //     this.filterParam = this.tableFilters + '&primaryMobileNo-eq=' + this.primaryMobileNo;
          //     this.api_error = 'Country code should be given along with ph no';
          //     setTimeout(() => {
          //       this.api_error = '';
          //     }, 3000);

          //     this.consumerCount = 0;
          //   }
          //   else {
          //     alert('4')
          //     this.filterParam = this.tableFilters + '&countryCode-eq=' + this.countryCode + '&&primaryMobileNo-eq=' + this.primaryMobileNo;

          //   }
          // }
          // else if (this.customerSpecificFilters !== '' || this.customerSpecificFilters !== undefined) {
          //   this.userAgentFilter = this.commonFilter.filterParams_without_operators('consumer_userAgent');
          //   this.filterParam = this.tableFilters + '&' + this.customerSpecificFilters + '&' + this.userAgentFilter;
          // }
          // else {
          //   this.filterParam = this.tableFilters + '&' + this.customerSpecificFilters + '&' + this.userAgentFilter + '&countryCode-eq=' + this.countryCode + '&&primaryMobileNo-eq=' + this.primaryMobileNo;
          // }
          this.getTotalCountByFilters(this.filterParam);
          this.paginator.pageIndex = 0;
          this.loadCustomersPage(this.filterParam);
          this.showToolBar = false;
          this.fromDashboard = true;
          this.fromOffer = false;
          this.selectedRowIndex = -1;
        })
      )
      .subscribe();
  }
  getTotalCount() {
    this.customerService.getCount()
      .subscribe(
        res => {
          this.consumerCount = res;
          console.log(this.consumerCount)
        });
  }
  getTotalCountByFilters(filter) {
    this.customerService.getTotalFilterCount(filter)
      .subscribe(data => this.consumerCount = data);
    console.log(this.consumerCount)
  }
  loadCustomersPage(filterParam?) {
    const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
    if (filterParam) {
      this.dataSource.loadCustomers(

        filterParam,
        'false',
        count,
        this.paginator.pageSize);

    }
    // else {
    //   alert('fd')
    //   this.dataSource.loadCustomers(

    //     this.tableFilters,
    //     'false',
    //     count,
    //     this.paginator.pageSize);
    // }
  }
  onRowClicked(row) {
    this.selectedRowIndex = row.id;
    this.customerData = row;
    this.showToolBar = true;

  }
  realCustomer(): void {
    const dialogRef = this.dialog.open(ChangeRealComponent, {
      width: '600px',
      data: this.customerData,

    });
    dialogRef.afterClosed().subscribe(result => {
      const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.dataSource.loadCustomers(this.tableFilters, 'false', count, this.paginator.pageSize);
    });
  }
  deleteCustomer(): void {
    const dialogRef = this.dialog.open(DeleteCustomerDialogComponent, {
      width: '600px',
      data: this.selectedRowIndex
    });

    dialogRef.afterClosed().subscribe(result => {
      const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.dataSource.loadCustomers(this.tableFilters, 'false', count, this.paginator.pageSize);
    });
  }
  rejectEmail(): void {

    const dialogRef = this.dialog.open(EmailVerifyDialogComponent, {
      width: '600px',
      data: { 'account': this.selectedRowIndex, 'type': 'customer' }
    });
    dialogRef.afterClosed().subscribe(result => {
      const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.dataSource.loadCustomers(this.tableFilters, 'false', count, this.paginator.pageSize);
    });
  }
  changeStatus() {
    const dialogRef = this.dialog.open(ChangeStatusDialogComponent, {
      width: '600px',
      data: this.selectedRowIndex
    });
    dialogRef.afterClosed().subscribe(result => {
      const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.dataSource.loadCustomers(this.tableFilters, 'false', count, this.paginator.pageSize);

    });
  }
  changePhone() {
    const dialogRef = this.dialog.open(ChangePhoneComponent, {
      width: '600px',
      data: this.selectedRowIndex
    });
    dialogRef.afterClosed().subscribe(result => {
      const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.dataSource.loadCustomers(this.tableFilters, 'false', count, this.paginator.pageSize);

    });
  }
  // changePhone() {

  //   const dialogRef = this.dialog.open(ChangePhoneComponent, {
  //     width: '600px',
  //     data: this.selectedRowIndex
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 10;
  //     this.selectedRowIndex = -1;
  //     this.showToolBar = false;
  //     this.dataSource.loadCustomers( this.tableFilters, 'false', count, this.paginator.pageSize);

  //   });
  // }
  ngOnDestroy() {
    this.customerService.setConsumerCategory(0);
    this.customerService.setUserAgentFilterParam(0);
    this.hideUserAgent = true;
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.customerDatas.length;
    return numSelected === numRows
  }



  /** Selects all rows if they are not all selected; otherwise clear selection. */
  // masterToggle(ref) {
  //   // console.log(ref);
  //   // if there is a selection then clear that selection
  //   if (this.isSomeSelected()) {

  //     this.selection.clear();
  //   ref.checked=false;

  //   } else {
  //     this.isAllSelected() ?
  //       this.selection.clear() :
  //       this.dataSource.customerDatas.forEach(row => this.selection.select(row));
  //   }
  //   // console.log(ref);
  // }

  isSomeSelected() {
    // console.log(this.selection.selected);
    if (this.selection.selected.length > 0) {
      this.issueCashBt = true;
    }
    else {
      this.issueCashBt = false;
    }
    return this.selection.selected.length > 0;
  }

  masterToggle($event) {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.customerDatas.forEach(row => this.selection.select(row));
    let masterValue = $event.target.checked;
    if (masterValue) {
      this.issueCashBt = true;
    }
    else {
      this.issueCashBt = false;
    }
  }

  IssueJaldeeCash() {
    let custArr = [];
    custArr = this.selection.selected;
    const dialogRef = this.dialog.open(IssueJcashComponent, {
      width: '600px',
      data: { 'accId': custArr }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.issueCashBt = false;
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.dataSource.loadCustomers(this.tableFilters, 'false', 0, 100);
    });
  }
}
export class ConsumerDataSource implements DataSource<any> {
  customerDatas: any;
  private customerSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private customerService: CustomerService) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any> {
    return this.customerSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.customerSubject.complete();
    this.loadingSubject.complete();
  }
  loadCustomers(filter,
    sortDirection, count, pageSize) {
    this.loadingSubject.next(true);
    this.customerService.getCustomers(filter, sortDirection,
      count, pageSize).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(customers => {
        this.customerDatas = customers;
        this.customerSubject.next(customers)
      }
      );

  }
  loadCustomersOffer(filter,
    sortDirection, count, pageSize) {
    this.loadingSubject.next(true);
    this.customerService.getCustomersFromOffer(filter, sortDirection,
      count, pageSize).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(customers => this.customerSubject.next(customers));
  }
}